import React from "react";
import {
  Center,
  Grid,
  GridItem,
  HStack,
  Stat,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";

const MonthlyStatsRow = ({
  statCellProps,
  headerBg,
  monthlyPnlBg,
  monthlyPnlValue,
  greenDayCount,
  redDayCount,
  greenDayPercent,
  redDayPercent,
  breakEvenPercent,
  onMonthlyPnlClick,
  formatPercent,
}) => {
  const stats = [
    { label: "# Green Days", value: greenDayCount },
    { label: "# Red Days", value: redDayCount },
    { label: "% Green Days", value: formatPercent(greenDayPercent) },
    { label: "% Red Days", value: formatPercent(redDayPercent) },
    { label: "% Break Even", value: formatPercent(breakEvenPercent) },
  ];

  return (
    <HStack spacing={4} mx="auto">
      <Grid templateColumns="repeat(6, 1fr)" gap={4}>
        <GridItem
          {...statCellProps}
          _hover={{ bg: "gray.400" }}
          bg={monthlyPnlBg}
          onClick={onMonthlyPnlClick}
          cursor="pointer"
        >
          <Center fontWeight="bold">
            <Stat>
              <StatLabel>Monthly PnL</StatLabel>
              <StatNumber>{monthlyPnlValue}</StatNumber>
            </Stat>
          </Center>
        </GridItem>
        {stats.map(({ label, value }) => (
          <GridItem key={label} {...statCellProps} bg={headerBg}>
            <Center fontWeight="bold">
              <Stat>
                <StatLabel>{label}</StatLabel>
                <StatNumber>{value}</StatNumber>
              </Stat>
            </Center>
          </GridItem>
        ))}
      </Grid>
    </HStack>
  );
};

export default MonthlyStatsRow;
